import { useState, useEffect } from 'react';
import { api } from './hrApi';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './hrAuth';

export default function Team() {
  const { user } = useAuth();
  const [members, setMembers] = useState([]);
  const [filter, setFilter] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api('/team').then(d => setMembers(d.members)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = members.filter(m =>
    !filter || `${m.employee_id} ${m.name} ${m.department} ${m.designation}`.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <section className="page on">
      <h2 className="pagetitle display">Team</h2>
      <div className="pagesub">{user.role==='admin'?'All active employees.':'Your reportees and scoped employees.'}</div>
      <div className="empsel">
        <input className="searchbox" placeholder="Search name / ID / department…"
               value={filter} onChange={e => setFilter(e.target.value)} />
      </div>
      {loading ? <div className="loading">Loading…</div> : !filtered.length ? <div className="loading">No employees in scope.</div> : (
        <table className="t">
          <thead><tr><th>EMP ID</th><th>NAME</th><th>DESIGNATION</th><th>DEPARTMENT</th><th>REPORTS TO</th><th>FACE</th><th></th></tr></thead>
          <tbody>{filtered.map(m => (
            <tr key={m.employee_id}>
              <td>{m.employee_id}</td><td>{m.name}</td>
              <td>{m.designation||'—'}</td><td>{m.department||'—'}</td>
              <td>{m.reporting_to||'—'}</td>
              <td><span className={`pill ${m.face_enrolled?'ok':'mut'}`}>{m.face_enrolled?'Enrolled':'Missing'}</span></td>
              <td>
                <button className="tinybtn" onClick={() => navigate('/my-hr/attendance?emp='+m.employee_id)}>Attendance</button>
                <button className="tinybtn" onClick={() => navigate('/my-hr/history?emp='+m.employee_id)}>History</button>
              </td>
            </tr>
          ))}</tbody>
        </table>
      )}
    </section>
  );
}
